import { useHistory } from "../../../../../../store/service/veterinary/useHistory";

import { InformationBlock as Container, Highlight, Line, Title } from "../styles";

export function BodyExamination() {
  const selectHistoryProcedure = useHistory((st) => st.data.selectHistoryProcedure);
  const procedureData = useHistory((st) => st.data.historyProcedureData);

  const selectedProcedure = procedureData[selectHistoryProcedure]
  const procedureRecord = selectedProcedure?.record

  return (
    <Container>
      <Title>Exame Corporal</Title>
      <Line>
        <p>
          <Highlight>Tórax: </Highlight> {procedureRecord?.chest || '-'}
        </p>
      </Line>
      <Line>
        <p>
          <Highlight>Abdome: </Highlight> {procedureRecord?.abdomen || '-'}
        </p>
      </Line>
      <Line>
        <p>
          <Highlight>Membros Torácicos: </Highlight> {procedureRecord?.thoracicLimbs || '-'}
        </p>
      </Line>
      <Line>
        <p>
          <Highlight>Membros Pélvicos: </Highlight> {procedureRecord?.pelvicLimbs || '-'}
        </p>
      </Line>
    </Container>
  );
}
